import LaunchCountdown from '../LaunchCountdown/LaunchCountdown';
import APP_DATA from '../../data/App';
import './Hero.css';

function Hero({ title, hook, blurb, handleLaunchTimerExpiry, hasLaunched}) {
  // const images = ["/Canuckz0009.png", "/Canuckz0016.png",  "/Canuckz0002.png"]
  return (
    <>
      <section className="hero is-small c_large-margin-top">
        <div className="hero-body">  
          <div className="container">
          {/* <img src="placeholder_menu_area.png" alt="sdfs" /> */}
            <div className="columns is-vcentered">   
              <div id="hero-panel" className="column is-6 is-6-tablet">
                <p id="hero-title" className="title is-1">{title}</p>
                <p id="hero-blurb">{blurb}</p>
                <p id="hero-hook">{hook}</p>
              </div>
              <div className="column is-6 is-6-tablet">
              
              <LaunchCountdown 
                launchDate={APP_DATA.launchDate} 
                handleLaunchTimerExpiry={handleLaunchTimerExpiry}
                hasLaunched={hasLaunched} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Hero;